import { render } from "./ReconciliationStep4.vue?vue&type=template&id=06c8f396"
import script from "./ReconciliationStep4.vue?vue&type=script&lang=js"
export * from "./ReconciliationStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__